import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  HostListener,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation,
  AfterContentChecked,
} from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { SubscriptionLike } from 'rxjs';
import {
  CalendarAvailabilities,
  CalendarEvents,
  CalendarEvent,
  DayViewConfig,
  TimeSlotEvent,
  SMDragEndEvent,
} from '../day-view-calendar/day-view-calendar.component';
import { CalendarService } from '../../../services/calendar.service';
import { BookingService } from '../../../services/booking.service';
import { StylistService } from '../../../services/stylist.service';
import { Stylist } from '../../../models';
import { Utilities } from '../../../utilities/utilities';
import { List, Map } from 'immutable';
import { IonSlides } from '@ionic/angular';

enum SCREEN_SIZE {
  'ExtraSmall' = 0,
  'Small' = 1,
  'Medium' = 2,
  'Large' = 3,
  'ExtraLarge' = 4,
}

interface MonthlyAvailabilities extends Map<string, CalendarAvailabilities> { }
@Component({
  selector: 'smr-week-view-calendar',
  templateUrl: './week-view-calendar.component.html',
  styleUrls: ['./week-view-calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WeekViewCalendarComponent
  implements OnInit, OnChanges, OnDestroy, AfterContentChecked {
  @ViewChild(IonSlides) slides: IonSlides;

  slideOpts = {
    initialSlide: 1,
  };

  @Input() currentDate: Date;

  @Input() stylist: Stylist;

  @Input() muteEventTappability: boolean;

  @Input() daysToDisplay: number;

  @Output() onTimeSelected = new EventEmitter<TimeSlotEvent>();

  @Output() onEventSelected = new EventEmitter<CalendarEvent>();

  @Output() onRangeChanged = new EventEmitter<List<DayViewConfig>>();
  @Output() onViewChanged = new EventEmitter<List<DayViewConfig>>();
  @Output() onError = new EventEmitter<any>();

  @Output() eventsBeforeUpdate = new EventEmitter<boolean>();

  @Output() eventsDidUpdate = new EventEmitter<boolean>();

  @Output() onEventDragEnd = new EventEmitter<SMDragEndEvent>();

  @HostListener('window:orientationchange', ['$event'])
  orientationChangedHandler(event) {
    if (this.init) {
    }
  }

  public startDate: Date;

  public endDate: Date;

  public screenSize: SCREEN_SIZE;

  public numOfViews: number;

  public views: List<DayViewConfig>;

  public prevViews: List<DayViewConfig>;

  public nextViews: List<DayViewConfig>;

  public init: boolean;

  public calendarMonitor$: SubscriptionLike;

  public deviceOrientationChanged: boolean;

  public cachedYear: string;

  public cachedMonth: string;

  public cachedMonthlyAvailabilities: MonthlyAvailabilities;

  public isMobile: boolean;

  public firstLoad: boolean = true;

  public viewsList: Array<List<DayViewConfig>>;

  @Output() newSelectedDate = new EventEmitter();

  constructor(
    private platform: Platform,
    private changeDetectorRef: ChangeDetectorRef,
    private bookingService: BookingService,
    private calendarService: CalendarService,
    private stylistService: StylistService,
    private cdr: ChangeDetectorRef
  ) {
    this.views = List.of<DayViewConfig>();
    this.prevViews = List.of<DayViewConfig>();
    this.nextViews = List.of<DayViewConfig>();
    this.viewsList = [];
  }

  public ngOnInit() {
    this.init = true;

    this.platform.ready().then(() => {
      this.currentDate = this.currentDate || new Date();
      this.isMobile = this.platform.is('mobile');
    });

    this.calendarMonitor$ = this.calendarService
      .getCalendarUpdateMonitor()
      .subscribe((update) => {
        if (update) {
          let viewDate: Date = Utilities.cloneDate(this.currentDate);
          this.renderViews(viewDate);
        }
      });
  }

  ngAfterContentChecked() { }

  public ngOnDestroy() {
    this.calendarMonitor$.unsubscribe();
  }

  public ngOnChanges(changes) {
    if (this.init || changes['stylist'] || changes['currentDate'] || changes['daysToDisplay']) {
      let viewDate: Date = Utilities.cloneDate(this.currentDate);
      // after the initial load set init to false
      if (this.init) this.init = false;
      this.renderViews(viewDate);
    }
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    const width = event.target.innerWidth;
    let viewDate: Date = Utilities.cloneDate(this.currentDate);
    this._adjustColumnWidth(width, viewDate, true);
    this.cdr.detectChanges();
    this.onViewChanged.emit(this.views);
  }
  public renderViews(viewDate) {
    if (!this.stylist || this.stylist.id === 0) {
      this.changeDetectorRef.markForCheck();
      return;
    }

    this.platform.ready().then(async () => {
      const platformWidth: number = this.platform.width();
      this.cachedMonthlyAvailabilities = Map();
      this.numOfViews = this.getNumberOfViewsToRender();
      this.prevViews = List.of<DayViewConfig>();
      this.nextViews = List.of<DayViewConfig>();
      this.views = List.of<DayViewConfig>();

      this.eventsBeforeUpdate.emit(true);
      this.updateRange();

      this._adjustColumnWidth(platformWidth, viewDate);
      var startDate = Utilities.cloneDate(this.startDate);
      var endDate = Utilities.cloneDate(this.endDate);
      viewDate = Utilities.addDays(viewDate, 1);
      await this.loadData(startDate, endDate);
    });
  }

  public getNumberOfViewsToRenderOLD(screenSize: SCREEN_SIZE): number {
    if (screenSize === SCREEN_SIZE.ExtraSmall) {
      return 1;
    } else if (screenSize === SCREEN_SIZE.Small) {
      return 3;
    } else if (screenSize === SCREEN_SIZE.Medium) {
      return 4;
    } else if (screenSize === SCREEN_SIZE.Large) {
      return 7;
    } else if (screenSize === SCREEN_SIZE.ExtraLarge) {
      return 7;
    }
  }

  public getNumberOfViewsToRender(): number {
    if (this.daysToDisplay) return this.daysToDisplay;
    if (this.platform.is('ios')) {
      if (this.platform.is('phablet')) {
        return 3;
      } else if (this.platform.is('tablet')) {
        return 7;
      } else {
        return 1;
      }
    } else if (this.platform.is('android')) {
      if (this.platform.is('phablet')) {
        return 3;
      } else if (this.platform.is('tablet')) {
        return 7;
      } else {
        return 1;
      }
    } else {
      // web, desktop, always return 7
      return 7;
    }
  }

  public getScreenSize(width: number): SCREEN_SIZE {
    if (width < 576) {
      return SCREEN_SIZE.ExtraSmall;
    } else if (width < 768) {
      return SCREEN_SIZE.Small;
    } else if (width < 992) {
      return SCREEN_SIZE.Medium;
    } else if (width < 1200) {
      return SCREEN_SIZE.Large;
    } else {
      return SCREEN_SIZE.ExtraLarge;
    }
  }

  public async loadData(startDate, endDate) {
    const viewsListStartDate = Utilities.subtractDays(
      startDate,
      this.numOfViews
    );
    const viewsListEndDate = Utilities.addDays(endDate, this.numOfViews);

    try {
      const bookings = await this.bookingService
        .loadBookings(
          viewsListStartDate,
          viewsListEndDate,
          this.stylist.getID()
        )
        .toPromise();
      const newEvents: CalendarEvents = this.calendarService.groupBookings(
        this.stylist,
        bookings
      );

      const availabilities = await this.fetchAvailabilities(
        viewsListStartDate,
        viewsListEndDate
      );
      let counter = this.numOfViews;
      let viewDate: Date = Utilities.cloneDate(startDate);

      for (let i = 0; i < counter; i++) {
        let dayViewAvailabilitiy: any;
        const month: string = Utilities.formatDate(viewDate, 'M');
        const day: string = Utilities.formatDate(viewDate, 'D');

        if (availabilities.has(month) && availabilities.get(month).has(day)) {
          dayViewAvailabilitiy = availabilities.getIn([month, day]);
        }

        this.views = this.views.update(i, (dayConfig) => {
          return dayConfig
            .setDate(viewDate)
            .setEvents(newEvents)
            .setAvailabilities(dayViewAvailabilitiy)
            .setStylist(this.stylist);
        });

        viewDate = Utilities.addDays(viewDate, 1);
      }

      this.onRangeChanged.emit(this.views);
      this.changeDetectorRef.markForCheck();
      this.eventsDidUpdate.emit(true);

      return this.views;
    } catch (err) {
      throw new Error(err);
    }
  }

  public async fetchAvailabilities(startDate, endDate) {
    let primaryYear: string;
    let primaryMonth: string;
    let secondaryYear: string;
    let secondaryMonth: string;

    let availabilities: MonthlyAvailabilities = Map();

    let viewDate: Date = Utilities.cloneDate(startDate);
    while (
      Utilities.isBefore(viewDate, endDate) ||
      Utilities.isEqual(viewDate, endDate)
    ) {
      const year: string = Utilities.formatDate(viewDate, 'Y');
      const month: string = Utilities.formatDate(viewDate, 'M');

      viewDate = Utilities.addDays(viewDate, 1);

      if (primaryMonth === undefined) {
        primaryYear = year;
        primaryMonth = month;
        continue;
      }

      if (primaryMonth !== month) {
        secondaryYear = year;
        secondaryMonth = month;
        continue;
      }
    }

    try {
      const primaryAvailabilities = await this.stylistService
        .getAvailabilities(this.stylist, primaryYear, primaryMonth)
        .toPromise();
      availabilities = availabilities.set(primaryMonth, primaryAvailabilities);

      if (secondaryYear !== undefined) {
        const secondaryAvailabilities = await this.stylistService
          .getAvailabilities(this.stylist, secondaryYear, secondaryMonth)
          .toPromise();
        if (secondaryAvailabilities) {
          availabilities = availabilities.set(
            secondaryMonth,
            secondaryAvailabilities
          );
        }
      }
    } catch (error) {
      throw error;
    }

    return availabilities;
  }

  private updateRange() {
    // Start with the nearest Sunday from the start date if the week calendar is in full mode (contains 7 DayViewCalendar)
    if (this.daysToDisplay === 7) {
      let days: List<string> = List.of(
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      );
      let index: number = 0;

      days.some((day) => {
        const d = Utilities.formatDate(this.currentDate, 'dddd');

        if (d === day) {
          return true;
        }

        index++;

        return false;
      });

      this.startDate = Utilities.subtractDays(
        Utilities.cloneDate(this.currentDate),
        index
      );
    } else {
      // start with the current date if the week calendar contains less then 7 DayViewCalendar
      this.startDate = Utilities.cloneDate(this.currentDate);
    }
    this.endDate = Utilities.addDays(this.startDate, this.numOfViews - 1);
  }

  public eventSelectedHandler(event) {
    this.onEventSelected.emit(event);
  }

  public onTimeSelectedHandler(event: TimeSlotEvent) {
    this.onTimeSelected.emit(event);
  }

  public onEventDragEndHandler($event) {
    this.onEventDragEnd.emit($event);
  }

  public trackByFn(index, item) {
    //src: https://github.com/angular/angular/issues/10182
    // src: https://netbasal.com/angular-2-improve-performance-with-trackby-cc147b5104e5
    return index; // or item.id
  }

  // onSlideChange(event:any){
  //   if(event[0].activeIndex == 0){
  //     this.loadPrev(event[0].activeIndex)
  //   }
  //   if(event[0].activeIndex == 2){
  //     this.loadNext()
  //   }
  // }

  // public loadPrevViews() {}

  // public loadNextViews() {}

  private _adjustColumnWidth(
    platformWidth: number,
    viewDate: Date,
    fetchStatus = false
  ) {
    for (let i = 0; i < this.numOfViews; i++) {
      let hideHourCol: boolean = i % 2 === 1;

      let hourColWidth: number = 45;
      let minuteColWidth: number = 16;
      let numOfViewsWithHourCol: number = Math.ceil(this.numOfViews / 2);
      if (platformWidth < 750 && platformWidth > 450) {
        hourColWidth = 30;
        minuteColWidth = 11;
      }
      if (platformWidth < 450) {
        if (i > 0) {
          // hide the hour column for all but the first view
          hideHourCol = true;
        }
        numOfViewsWithHourCol = 1;
        hourColWidth = 25;
        minuteColWidth = 11;
      }

      let baseWidth: string = `calc((100% - ${(hourColWidth + minuteColWidth * 2) * numOfViewsWithHourCol -
        minuteColWidth
        }px) / ${this.numOfViews})`;
      let width: string = '';

      if (i === 0) {
        width = `calc(${hourColWidth + minuteColWidth}px + ${baseWidth})`;
      } else {
        width = `calc(${hideHourCol ? 0 : hourColWidth + minuteColWidth + minuteColWidth
          }px + ${baseWidth})`;
      }
      if (fetchStatus === true) {
        const currentView = this.views.get(i).setWidth(width);
        this.views = this.views.set(i, currentView);
      } else {
        this.views = this.views.push(
          new DayViewConfig({
            date: viewDate,
            events: undefined,
            availabilities: undefined,
            stylist: this.stylist,
            hideTimeSlotLabels: hideHourCol,
            showLeftMinuteLabels: i > 0,
            width: width,
            muteEventTappability: this.muteEventTappability,
          })
        );
      }
    }
  }
}

//         0     1    2
// arr = [arr1, arr2, arr3]

// loadPrev(){
//   arr = [arr4, arr1, arr2]
// }

// OPTION 1
// call renderView
// load data
// hash data and save to local Storage
// if hash is different then re-render

// OPTION 2
// update or create a new api endpoint
// send the endpoint the date rangeChanged
// endpoint returns a hash value for each day
// if the hash value for a day doesn't match our local hash value THEN we load the full data

/*
  {
    2022-11-30: fasdf87sdyafsadyfasd8f,
    2022-12-01: dadf78yfasfufhsdkfhsdf,
    2022-12-02: 49tsdlgdfgfdjlkjlkjlkj,
    ...
    ...
  }

*/

/* 3 scenarios: 
1. we haven't loaded that day before: load that day's data an render it
2. we have loaded that day before, BUT the hash has changed, load that day's data again and render it
3. we have loaded that day before and there is no change, just use the existing rendered data and view
*/
